import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({ providedIn: 'root' })
export class SnackbarService {
    constructor(private snackbar: MatSnackBar) { }

    error(message: string): void {
        this.snackbar.open(message, 'close', {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            panelClass: [
                'border-4',
                'border-red-400',
                'border-solid',
                'rounded-lg'
            ],
        });
    }

    // Amber, and open longer than the others - the messages that use it (e.g. storage requirements) are long.
    warning(message: string): void {
        this.snackbar.open(message, 'close', {
            duration: 10000,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            panelClass: [
                'border-4',
                'border-amber-400',
                'border-solid',
                'rounded-lg'
            ],
        });
    }

    success(message: string): void {
        this.snackbar.open(message, 'close', {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            panelClass: [
                'border-4',
                'border-green-400',
                'border-solid',
                'rounded-lg'
            ],
        });
    }
}